/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardGenerateLeagueRanking,
  DashboardGenerateLeagueRankingResult,
  DashboardLeagueRankingDates,
  DashboardLeagueRankingHistory,
  DashboardLeagueRankingList,
  DashboardLeagueRankingPointsDetail,
  DashboardLeagueRankingRule,
  DashboardLeagueRankingRuleItem,
  DashboardLeagueRankingSchedule,
  DashboardLeagueRankingsControllerCreateRule400,
  DashboardLeagueRankingsControllerCreateRule401,
  DashboardLeagueRankingsControllerCreateRule403,
  DashboardLeagueRankingsControllerCreateRule404,
  DashboardLeagueRankingsControllerCreateRule409,
  DashboardLeagueRankingsControllerCreateRule429,
  DashboardLeagueRankingsControllerDates400,
  DashboardLeagueRankingsControllerDates401,
  DashboardLeagueRankingsControllerDates403,
  DashboardLeagueRankingsControllerDates404,
  DashboardLeagueRankingsControllerDates429,
  DashboardLeagueRankingsControllerDatesParams,
  DashboardLeagueRankingsControllerDeleteRule400,
  DashboardLeagueRankingsControllerDeleteRule401,
  DashboardLeagueRankingsControllerDeleteRule403,
  DashboardLeagueRankingsControllerDeleteRule404,
  DashboardLeagueRankingsControllerDeleteRule429,
  DashboardLeagueRankingsControllerDeleteSnapshot400,
  DashboardLeagueRankingsControllerDeleteSnapshot401,
  DashboardLeagueRankingsControllerDeleteSnapshot403,
  DashboardLeagueRankingsControllerDeleteSnapshot404,
  DashboardLeagueRankingsControllerDeleteSnapshot429,
  DashboardLeagueRankingsControllerGenerate400,
  DashboardLeagueRankingsControllerGenerate401,
  DashboardLeagueRankingsControllerGenerate403,
  DashboardLeagueRankingsControllerGenerate404,
  DashboardLeagueRankingsControllerGenerate429,
  DashboardLeagueRankingsControllerGenerate503,
  DashboardLeagueRankingsControllerGetRule400,
  DashboardLeagueRankingsControllerGetRule401,
  DashboardLeagueRankingsControllerGetRule403,
  DashboardLeagueRankingsControllerGetRule404,
  DashboardLeagueRankingsControllerGetRule429,
  DashboardLeagueRankingsControllerGetSchedule400,
  DashboardLeagueRankingsControllerGetSchedule401,
  DashboardLeagueRankingsControllerGetSchedule403,
  DashboardLeagueRankingsControllerGetSchedule404,
  DashboardLeagueRankingsControllerGetSchedule429,
  DashboardLeagueRankingsControllerHistory400,
  DashboardLeagueRankingsControllerHistory401,
  DashboardLeagueRankingsControllerHistory403,
  DashboardLeagueRankingsControllerHistory404,
  DashboardLeagueRankingsControllerHistory429,
  DashboardLeagueRankingsControllerHistoryParams,
  DashboardLeagueRankingsControllerList400,
  DashboardLeagueRankingsControllerList401,
  DashboardLeagueRankingsControllerList403,
  DashboardLeagueRankingsControllerList404,
  DashboardLeagueRankingsControllerList429,
  DashboardLeagueRankingsControllerListParams,
  DashboardLeagueRankingsControllerListRules400,
  DashboardLeagueRankingsControllerListRules401,
  DashboardLeagueRankingsControllerListRules403,
  DashboardLeagueRankingsControllerListRules404,
  DashboardLeagueRankingsControllerListRules429,
  DashboardLeagueRankingsControllerPointsDetail400,
  DashboardLeagueRankingsControllerPointsDetail401,
  DashboardLeagueRankingsControllerPointsDetail403,
  DashboardLeagueRankingsControllerPointsDetail404,
  DashboardLeagueRankingsControllerPointsDetail429,
  DashboardLeagueRankingsControllerPointsDetailParams,
  DashboardLeagueRankingsControllerResetSchedule400,
  DashboardLeagueRankingsControllerResetSchedule401,
  DashboardLeagueRankingsControllerResetSchedule403,
  DashboardLeagueRankingsControllerResetSchedule404,
  DashboardLeagueRankingsControllerResetSchedule429,
  DashboardLeagueRankingsControllerSetSchedule400,
  DashboardLeagueRankingsControllerSetSchedule401,
  DashboardLeagueRankingsControllerSetSchedule403,
  DashboardLeagueRankingsControllerSetSchedule404,
  DashboardLeagueRankingsControllerSetSchedule429,
  DashboardLeagueRankingsControllerSetVisibility400,
  DashboardLeagueRankingsControllerSetVisibility401,
  DashboardLeagueRankingsControllerSetVisibility403,
  DashboardLeagueRankingsControllerSetVisibility404,
  DashboardLeagueRankingsControllerSetVisibility429,
  DashboardLeagueRankingsControllerUpdateRule400,
  DashboardLeagueRankingsControllerUpdateRule401,
  DashboardLeagueRankingsControllerUpdateRule403,
  DashboardLeagueRankingsControllerUpdateRule404,
  DashboardLeagueRankingsControllerUpdateRule429,
  DashboardSetLeagueRankingSchedule,
  DashboardSetLeagueRankingVisibility,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * One snapshot of a league ranking, ordered by place (default). `leagueId` (`lge_…`) and `rankingCategoryId` (`rct_…`) are required; when `date` is omitted the latest snapshot for that (league, category) is used. Each row carries its previous-snapshot delta (`previousPlace`/`previousPoints`) for the movement arrow. Access-checked: an out-of-scope league is a 403, a `rct_` that is not in the league is a 404.
 * @summary Current league-ranking leaderboard (dashboard)
 */
export const dashboardLeagueRankingsControllerList = (
  params: DashboardLeagueRankingsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingList>(
    { url: `/api/dashboard/v1/league-rankings`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerListQueryKey = (
  params: DashboardLeagueRankingsControllerListParams
) => {
  return [`/api/dashboard/v1/league-rankings`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueRankingsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerList400
    | DashboardLeagueRankingsControllerList401
    | DashboardLeagueRankingsControllerList403
    | DashboardLeagueRankingsControllerList404
    | DashboardLeagueRankingsControllerList429
  >,
>(
  params: DashboardLeagueRankingsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>
  > = ({ signal }) => dashboardLeagueRankingsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>
>;
export type DashboardLeagueRankingsControllerListQueryError = ErrorType<
  | DashboardLeagueRankingsControllerList400
  | DashboardLeagueRankingsControllerList401
  | DashboardLeagueRankingsControllerList403
  | DashboardLeagueRankingsControllerList404
  | DashboardLeagueRankingsControllerList429
>;

export function useDashboardLeagueRankingsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerList400
    | DashboardLeagueRankingsControllerList401
    | DashboardLeagueRankingsControllerList403
    | DashboardLeagueRankingsControllerList404
    | DashboardLeagueRankingsControllerList429
  >,
>(
  params: DashboardLeagueRankingsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerList400
    | DashboardLeagueRankingsControllerList401
    | DashboardLeagueRankingsControllerList403
    | DashboardLeagueRankingsControllerList404
    | DashboardLeagueRankingsControllerList429
  >,
>(
  params: DashboardLeagueRankingsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerList400
    | DashboardLeagueRankingsControllerList401
    | DashboardLeagueRankingsControllerList403
    | DashboardLeagueRankingsControllerList404
    | DashboardLeagueRankingsControllerList429
  >,
>(
  params: DashboardLeagueRankingsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Current league-ranking leaderboard (dashboard)
 */

export function useDashboardLeagueRankingsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerList400
    | DashboardLeagueRankingsControllerList401
    | DashboardLeagueRankingsControllerList403
    | DashboardLeagueRankingsControllerList404
    | DashboardLeagueRankingsControllerList429
  >,
>(
  params: DashboardLeagueRankingsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Distinct ranking snapshots for a league, newest first (one row per (ranking category, date) generation). Optional filters (all narrow the list; the item shape is unchanged): `rankingCategoryId` (`rct_…`, single) and `rankingCategoryIds` (`rct_…`, multiselect) are unioned into a category whitelist; `search` matches the ranking-category name (ILIKE, intersected with the whitelist); `updatedFrom`/`updatedTo` bound the snapshot generation time (`lastUpdated`); `ratingDate` (`DD-MM-YYYY`) matches the rating date exactly. Each item carries the ranking-category ref, date, generation time, athlete count and public flag.
 * @summary League-ranking history (dashboard)
 */
export const dashboardLeagueRankingsControllerHistory = (
  params: DashboardLeagueRankingsControllerHistoryParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingHistory>(
    { url: `/api/dashboard/v1/league-rankings/history`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerHistoryQueryKey = (
  params: DashboardLeagueRankingsControllerHistoryParams
) => {
  return [`/api/dashboard/v1/league-rankings/history`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueRankingsControllerHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerHistory400
    | DashboardLeagueRankingsControllerHistory401
    | DashboardLeagueRankingsControllerHistory403
    | DashboardLeagueRankingsControllerHistory404
    | DashboardLeagueRankingsControllerHistory429
  >,
>(
  params: DashboardLeagueRankingsControllerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>
  > = ({ signal }) => dashboardLeagueRankingsControllerHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>
>;
export type DashboardLeagueRankingsControllerHistoryQueryError = ErrorType<
  | DashboardLeagueRankingsControllerHistory400
  | DashboardLeagueRankingsControllerHistory401
  | DashboardLeagueRankingsControllerHistory403
  | DashboardLeagueRankingsControllerHistory404
  | DashboardLeagueRankingsControllerHistory429
>;

export function useDashboardLeagueRankingsControllerHistory<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerHistory400
    | DashboardLeagueRankingsControllerHistory401
    | DashboardLeagueRankingsControllerHistory403
    | DashboardLeagueRankingsControllerHistory404
    | DashboardLeagueRankingsControllerHistory429
  >,
>(
  params: DashboardLeagueRankingsControllerHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerHistory<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerHistory400
    | DashboardLeagueRankingsControllerHistory401
    | DashboardLeagueRankingsControllerHistory403
    | DashboardLeagueRankingsControllerHistory404
    | DashboardLeagueRankingsControllerHistory429
  >,
>(
  params: DashboardLeagueRankingsControllerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerHistory<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerHistory400
    | DashboardLeagueRankingsControllerHistory401
    | DashboardLeagueRankingsControllerHistory403
    | DashboardLeagueRankingsControllerHistory404
    | DashboardLeagueRankingsControllerHistory429
  >,
>(
  params: DashboardLeagueRankingsControllerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary League-ranking history (dashboard)
 */

export function useDashboardLeagueRankingsControllerHistory<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerHistory400
    | DashboardLeagueRankingsControllerHistory401
    | DashboardLeagueRankingsControllerHistory403
    | DashboardLeagueRankingsControllerHistory404
    | DashboardLeagueRankingsControllerHistory429
  >,
>(
  params: DashboardLeagueRankingsControllerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The per-tournament points breakdown behind one athlete's (or team's) row in a snapshot — the data source for the "points" modal. Supply exactly one of `userId` (`usr_…`) / `teamId` (`tm_…`). Each result carries the `counted` flag (whether it fed the ranking total). NOTE: the team breakdown is not yet computed — a `teamId` request returns the stored total with an empty `results` list (individual path is fully implemented).
 * @summary League-ranking points breakdown (dashboard)
 */
export const dashboardLeagueRankingsControllerPointsDetail = (
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingPointsDetail>(
    { url: `/api/dashboard/v1/league-rankings/points-detail`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerPointsDetailQueryKey = (
  params: DashboardLeagueRankingsControllerPointsDetailParams
) => {
  return [`/api/dashboard/v1/league-rankings/points-detail`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueRankingsControllerPointsDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerPointsDetail400
    | DashboardLeagueRankingsControllerPointsDetail401
    | DashboardLeagueRankingsControllerPointsDetail403
    | DashboardLeagueRankingsControllerPointsDetail404
    | DashboardLeagueRankingsControllerPointsDetail429
  >,
>(
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerPointsDetailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>
  > = ({ signal }) => dashboardLeagueRankingsControllerPointsDetail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerPointsDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>
>;
export type DashboardLeagueRankingsControllerPointsDetailQueryError = ErrorType<
  | DashboardLeagueRankingsControllerPointsDetail400
  | DashboardLeagueRankingsControllerPointsDetail401
  | DashboardLeagueRankingsControllerPointsDetail403
  | DashboardLeagueRankingsControllerPointsDetail404
  | DashboardLeagueRankingsControllerPointsDetail429
>;

export function useDashboardLeagueRankingsControllerPointsDetail<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerPointsDetail400
    | DashboardLeagueRankingsControllerPointsDetail401
    | DashboardLeagueRankingsControllerPointsDetail403
    | DashboardLeagueRankingsControllerPointsDetail404
    | DashboardLeagueRankingsControllerPointsDetail429
  >,
>(
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerPointsDetail<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerPointsDetail400
    | DashboardLeagueRankingsControllerPointsDetail401
    | DashboardLeagueRankingsControllerPointsDetail403
    | DashboardLeagueRankingsControllerPointsDetail404
    | DashboardLeagueRankingsControllerPointsDetail429
  >,
>(
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerPointsDetail<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerPointsDetail400
    | DashboardLeagueRankingsControllerPointsDetail401
    | DashboardLeagueRankingsControllerPointsDetail403
    | DashboardLeagueRankingsControllerPointsDetail404
    | DashboardLeagueRankingsControllerPointsDetail429
  >,
>(
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary League-ranking points breakdown (dashboard)
 */

export function useDashboardLeagueRankingsControllerPointsDetail<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerPointsDetail400
    | DashboardLeagueRankingsControllerPointsDetail401
    | DashboardLeagueRankingsControllerPointsDetail403
    | DashboardLeagueRankingsControllerPointsDetail404
    | DashboardLeagueRankingsControllerPointsDetail429
  >,
>(
  params: DashboardLeagueRankingsControllerPointsDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerPointsDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerPointsDetailQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * DEPRECATED — use `GET /:leagueId/rules` (the multi-rule surface) instead. The per-league rankings auto-update configuration (single row). `isEnabled` is true only when a config row exists AND has at least one ranking category. Ranking categories are returned as `rct_` refs.
 * @deprecated
 * @summary [Deprecated] Automatic-update (cron) config for a league (dashboard)
 */
export const dashboardLeagueRankingsControllerGetSchedule = (
  leagueId: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingSchedule>(
    { url: `/api/dashboard/v1/league-rankings/${leagueId}/schedule`, method: "GET", signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerGetScheduleQueryKey = (leagueId: string) => {
  return [`/api/dashboard/v1/league-rankings/${leagueId}/schedule`] as const;
};

export const getDashboardLeagueRankingsControllerGetScheduleQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetSchedule400
    | DashboardLeagueRankingsControllerGetSchedule401
    | DashboardLeagueRankingsControllerGetSchedule403
    | DashboardLeagueRankingsControllerGetSchedule404
    | DashboardLeagueRankingsControllerGetSchedule429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerGetScheduleQueryKey(leagueId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>
  > = ({ signal }) =>
    dashboardLeagueRankingsControllerGetSchedule(leagueId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!leagueId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerGetScheduleQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>
>;
export type DashboardLeagueRankingsControllerGetScheduleQueryError = ErrorType<
  | DashboardLeagueRankingsControllerGetSchedule400
  | DashboardLeagueRankingsControllerGetSchedule401
  | DashboardLeagueRankingsControllerGetSchedule403
  | DashboardLeagueRankingsControllerGetSchedule404
  | DashboardLeagueRankingsControllerGetSchedule429
>;

export function useDashboardLeagueRankingsControllerGetSchedule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetSchedule400
    | DashboardLeagueRankingsControllerGetSchedule401
    | DashboardLeagueRankingsControllerGetSchedule403
    | DashboardLeagueRankingsControllerGetSchedule404
    | DashboardLeagueRankingsControllerGetSchedule429
  >,
>(
  leagueId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerGetSchedule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetSchedule400
    | DashboardLeagueRankingsControllerGetSchedule401
    | DashboardLeagueRankingsControllerGetSchedule403
    | DashboardLeagueRankingsControllerGetSchedule404
    | DashboardLeagueRankingsControllerGetSchedule429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerGetSchedule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetSchedule400
    | DashboardLeagueRankingsControllerGetSchedule401
    | DashboardLeagueRankingsControllerGetSchedule403
    | DashboardLeagueRankingsControllerGetSchedule404
    | DashboardLeagueRankingsControllerGetSchedule429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @deprecated
 * @summary [Deprecated] Automatic-update (cron) config for a league (dashboard)
 */

export function useDashboardLeagueRankingsControllerGetSchedule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetSchedule400
    | DashboardLeagueRankingsControllerGetSchedule401
    | DashboardLeagueRankingsControllerGetSchedule403
    | DashboardLeagueRankingsControllerGetSchedule404
    | DashboardLeagueRankingsControllerGetSchedule429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetSchedule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerGetScheduleQueryOptions(
    leagueId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * DEPRECATED — use `POST` / `PUT /:leagueId/rules` (the multi-rule surface) instead. Create/replace the per-league rankings auto-update config (single row). `rankingCategoryIds` are `rct_` publicIds (translated to internal ids). Requires the league to have a platform assigned (the scheduler needs its timezone). Cadence-specific rules are enforced (weekly → day + time, monthly → first/last day + time, custom → non-empty date/time list). Returns the updated schedule.
 * @deprecated
 * @summary [Deprecated] Set the automatic-update (cron) config for a league (dashboard)
 */
export const dashboardLeagueRankingsControllerSetSchedule = (
  leagueId: string,
  dashboardSetLeagueRankingSchedule: BodyType<DashboardSetLeagueRankingSchedule>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardLeagueRankingSchedule>(
    {
      url: `/api/dashboard/v1/league-rankings/${leagueId}/schedule`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: dashboardSetLeagueRankingSchedule,
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerSetScheduleMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerSetSchedule400
    | DashboardLeagueRankingsControllerSetSchedule401
    | DashboardLeagueRankingsControllerSetSchedule403
    | DashboardLeagueRankingsControllerSetSchedule404
    | DashboardLeagueRankingsControllerSetSchedule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>,
    TError,
    { leagueId: string; data: BodyType<DashboardSetLeagueRankingSchedule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>,
  TError,
  { leagueId: string; data: BodyType<DashboardSetLeagueRankingSchedule> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>,
    { leagueId: string; data: BodyType<DashboardSetLeagueRankingSchedule> }
  > = (props) => {
    const { leagueId, data } = props ?? {};

    return dashboardLeagueRankingsControllerSetSchedule(leagueId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerSetScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>
>;
export type DashboardLeagueRankingsControllerSetScheduleMutationBody =
  BodyType<DashboardSetLeagueRankingSchedule>;
export type DashboardLeagueRankingsControllerSetScheduleMutationError = ErrorType<
  | DashboardLeagueRankingsControllerSetSchedule400
  | DashboardLeagueRankingsControllerSetSchedule401
  | DashboardLeagueRankingsControllerSetSchedule403
  | DashboardLeagueRankingsControllerSetSchedule404
  | DashboardLeagueRankingsControllerSetSchedule429
>;

/**
 * @deprecated
 * @summary [Deprecated] Set the automatic-update (cron) config for a league (dashboard)
 */
export const useDashboardLeagueRankingsControllerSetSchedule = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerSetSchedule400
    | DashboardLeagueRankingsControllerSetSchedule401
    | DashboardLeagueRankingsControllerSetSchedule403
    | DashboardLeagueRankingsControllerSetSchedule404
    | DashboardLeagueRankingsControllerSetSchedule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>,
    TError,
    { leagueId: string; data: BodyType<DashboardSetLeagueRankingSchedule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetSchedule>>,
  TError,
  { leagueId: string; data: BodyType<DashboardSetLeagueRankingSchedule> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerSetScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * DEPRECATED — use `DELETE /:leagueId/rules/:ruleId` (the multi-rule surface) instead. Clear the per-league rankings auto-update config (disables automatic updates). Idempotent — a league with no config returns 204 without error.
 * @deprecated
 * @summary [Deprecated] Reset the automatic-update (cron) config for a league (dashboard)
 */
export const dashboardLeagueRankingsControllerResetSchedule = (
  leagueId: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-rankings/${leagueId}/schedule`, method: "DELETE" },
    options
  );
};

export const getDashboardLeagueRankingsControllerResetScheduleMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerResetSchedule400
    | DashboardLeagueRankingsControllerResetSchedule401
    | DashboardLeagueRankingsControllerResetSchedule403
    | DashboardLeagueRankingsControllerResetSchedule404
    | DashboardLeagueRankingsControllerResetSchedule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>,
    TError,
    { leagueId: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>,
  TError,
  { leagueId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>,
    { leagueId: string }
  > = (props) => {
    const { leagueId } = props ?? {};

    return dashboardLeagueRankingsControllerResetSchedule(leagueId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerResetScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>
>;

export type DashboardLeagueRankingsControllerResetScheduleMutationError = ErrorType<
  | DashboardLeagueRankingsControllerResetSchedule400
  | DashboardLeagueRankingsControllerResetSchedule401
  | DashboardLeagueRankingsControllerResetSchedule403
  | DashboardLeagueRankingsControllerResetSchedule404
  | DashboardLeagueRankingsControllerResetSchedule429
>;

/**
 * @deprecated
 * @summary [Deprecated] Reset the automatic-update (cron) config for a league (dashboard)
 */
export const useDashboardLeagueRankingsControllerResetSchedule = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerResetSchedule400
    | DashboardLeagueRankingsControllerResetSchedule401
    | DashboardLeagueRankingsControllerResetSchedule403
    | DashboardLeagueRankingsControllerResetSchedule404
    | DashboardLeagueRankingsControllerResetSchedule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>,
    TError,
    { leagueId: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerResetSchedule>>,
  TError,
  { leagueId: string },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerResetScheduleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * All automatic-update rules for a league (each a schedule + assigned ranking categories + optional name), oldest first. A league holds at most 10 rules, so the list is unpaginated. Ranking categories are returned as `rct_` refs; `createdBy` is the user who created the rule (null for pre-existing / legacy rows). `leagueId` (`lge_…`) is access-checked — an out-of-scope league is a 403.
 * @summary List automatic-update rules for a league (dashboard)
 */
export const dashboardLeagueRankingsControllerListRules = (
  leagueId: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingRuleItem[]>(
    { url: `/api/dashboard/v1/league-rankings/${leagueId}/rules`, method: "GET", signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerListRulesQueryKey = (leagueId: string) => {
  return [`/api/dashboard/v1/league-rankings/${leagueId}/rules`] as const;
};

export const getDashboardLeagueRankingsControllerListRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerListRules400
    | DashboardLeagueRankingsControllerListRules401
    | DashboardLeagueRankingsControllerListRules403
    | DashboardLeagueRankingsControllerListRules404
    | DashboardLeagueRankingsControllerListRules429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerListRulesQueryKey(leagueId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>
  > = ({ signal }) => dashboardLeagueRankingsControllerListRules(leagueId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!leagueId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerListRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>
>;
export type DashboardLeagueRankingsControllerListRulesQueryError = ErrorType<
  | DashboardLeagueRankingsControllerListRules400
  | DashboardLeagueRankingsControllerListRules401
  | DashboardLeagueRankingsControllerListRules403
  | DashboardLeagueRankingsControllerListRules404
  | DashboardLeagueRankingsControllerListRules429
>;

export function useDashboardLeagueRankingsControllerListRules<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerListRules400
    | DashboardLeagueRankingsControllerListRules401
    | DashboardLeagueRankingsControllerListRules403
    | DashboardLeagueRankingsControllerListRules404
    | DashboardLeagueRankingsControllerListRules429
  >,
>(
  leagueId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerListRules<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerListRules400
    | DashboardLeagueRankingsControllerListRules401
    | DashboardLeagueRankingsControllerListRules403
    | DashboardLeagueRankingsControllerListRules404
    | DashboardLeagueRankingsControllerListRules429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerListRules<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerListRules400
    | DashboardLeagueRankingsControllerListRules401
    | DashboardLeagueRankingsControllerListRules403
    | DashboardLeagueRankingsControllerListRules404
    | DashboardLeagueRankingsControllerListRules429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List automatic-update rules for a league (dashboard)
 */

export function useDashboardLeagueRankingsControllerListRules<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerListRules400
    | DashboardLeagueRankingsControllerListRules401
    | DashboardLeagueRankingsControllerListRules403
    | DashboardLeagueRankingsControllerListRules404
    | DashboardLeagueRankingsControllerListRules429
  >,
>(
  leagueId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerListRules>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerListRulesQueryOptions(leagueId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create one automatic-update rule (schedule + ranking categories + optional name). A league may hold at most 10 rules — a further create is a 409 (`LEAGUE_RANKING_RULES_LIMIT_REACHED`). `rankingCategoryIds` are `rct_` publicIds (translated to internal ids). Requires the league to have a platform assigned (the scheduler needs its timezone). Cadence-specific rules are enforced (weekly → day + time, monthly → first/last day + time, custom → unique, ≤ 24 date/time pairs). Returns the created rule.
 * @summary Create an automatic-update rule for a league (dashboard)
 */
export const dashboardLeagueRankingsControllerCreateRule = (
  leagueId: string,
  dashboardLeagueRankingRule: BodyType<DashboardLeagueRankingRule>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingRuleItem>(
    {
      url: `/api/dashboard/v1/league-rankings/${leagueId}/rules`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardLeagueRankingRule,
      signal,
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerCreateRuleMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerCreateRule400
    | DashboardLeagueRankingsControllerCreateRule401
    | DashboardLeagueRankingsControllerCreateRule403
    | DashboardLeagueRankingsControllerCreateRule404
    | DashboardLeagueRankingsControllerCreateRule409
    | DashboardLeagueRankingsControllerCreateRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>,
    TError,
    { leagueId: string; data: BodyType<DashboardLeagueRankingRule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>,
  TError,
  { leagueId: string; data: BodyType<DashboardLeagueRankingRule> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>,
    { leagueId: string; data: BodyType<DashboardLeagueRankingRule> }
  > = (props) => {
    const { leagueId, data } = props ?? {};

    return dashboardLeagueRankingsControllerCreateRule(leagueId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerCreateRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>
>;
export type DashboardLeagueRankingsControllerCreateRuleMutationBody =
  BodyType<DashboardLeagueRankingRule>;
export type DashboardLeagueRankingsControllerCreateRuleMutationError = ErrorType<
  | DashboardLeagueRankingsControllerCreateRule400
  | DashboardLeagueRankingsControllerCreateRule401
  | DashboardLeagueRankingsControllerCreateRule403
  | DashboardLeagueRankingsControllerCreateRule404
  | DashboardLeagueRankingsControllerCreateRule409
  | DashboardLeagueRankingsControllerCreateRule429
>;

/**
 * @summary Create an automatic-update rule for a league (dashboard)
 */
export const useDashboardLeagueRankingsControllerCreateRule = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerCreateRule400
    | DashboardLeagueRankingsControllerCreateRule401
    | DashboardLeagueRankingsControllerCreateRule403
    | DashboardLeagueRankingsControllerCreateRule404
    | DashboardLeagueRankingsControllerCreateRule409
    | DashboardLeagueRankingsControllerCreateRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>,
    TError,
    { leagueId: string; data: BodyType<DashboardLeagueRankingRule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerCreateRule>>,
  TError,
  { leagueId: string; data: BodyType<DashboardLeagueRankingRule> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerCreateRuleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A single automatic-update rule scoped to its league (IDOR-safe: a rule that belongs to a different league is a 404, never a cross-league read). `leagueId` (`lge_…`) is access-checked — an out-of-scope league is a 403.
 * @summary Get one automatic-update rule (dashboard)
 */
export const dashboardLeagueRankingsControllerGetRule = (
  leagueId: string,
  ruleId: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingRuleItem>(
    { url: `/api/dashboard/v1/league-rankings/${leagueId}/rules/${ruleId}`, method: "GET", signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerGetRuleQueryKey = (
  leagueId: string,
  ruleId: string
) => {
  return [`/api/dashboard/v1/league-rankings/${leagueId}/rules/${ruleId}`] as const;
};

export const getDashboardLeagueRankingsControllerGetRuleQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetRule400
    | DashboardLeagueRankingsControllerGetRule401
    | DashboardLeagueRankingsControllerGetRule403
    | DashboardLeagueRankingsControllerGetRule404
    | DashboardLeagueRankingsControllerGetRule429
  >,
>(
  leagueId: string,
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerGetRuleQueryKey(leagueId, ruleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>
  > = ({ signal }) =>
    dashboardLeagueRankingsControllerGetRule(leagueId, ruleId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(leagueId && ruleId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerGetRuleQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>
>;
export type DashboardLeagueRankingsControllerGetRuleQueryError = ErrorType<
  | DashboardLeagueRankingsControllerGetRule400
  | DashboardLeagueRankingsControllerGetRule401
  | DashboardLeagueRankingsControllerGetRule403
  | DashboardLeagueRankingsControllerGetRule404
  | DashboardLeagueRankingsControllerGetRule429
>;

export function useDashboardLeagueRankingsControllerGetRule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetRule400
    | DashboardLeagueRankingsControllerGetRule401
    | DashboardLeagueRankingsControllerGetRule403
    | DashboardLeagueRankingsControllerGetRule404
    | DashboardLeagueRankingsControllerGetRule429
  >,
>(
  leagueId: string,
  ruleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerGetRule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetRule400
    | DashboardLeagueRankingsControllerGetRule401
    | DashboardLeagueRankingsControllerGetRule403
    | DashboardLeagueRankingsControllerGetRule404
    | DashboardLeagueRankingsControllerGetRule429
  >,
>(
  leagueId: string,
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerGetRule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetRule400
    | DashboardLeagueRankingsControllerGetRule401
    | DashboardLeagueRankingsControllerGetRule403
    | DashboardLeagueRankingsControllerGetRule404
    | DashboardLeagueRankingsControllerGetRule429
  >,
>(
  leagueId: string,
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get one automatic-update rule (dashboard)
 */

export function useDashboardLeagueRankingsControllerGetRule<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGetRule400
    | DashboardLeagueRankingsControllerGetRule401
    | DashboardLeagueRankingsControllerGetRule403
    | DashboardLeagueRankingsControllerGetRule404
    | DashboardLeagueRankingsControllerGetRule429
  >,
>(
  leagueId: string,
  ruleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGetRule>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerGetRuleQueryOptions(
    leagueId,
    ruleId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Replace an automatic-update rule (schedule + ranking categories + optional name), scoped to its league (IDOR-safe: a rule in a different league is a 404). Same cadence + custom-frequency rules and platform requirement as create. Returns the updated rule.
 * @summary Update an automatic-update rule (dashboard)
 */
export const dashboardLeagueRankingsControllerUpdateRule = (
  leagueId: string,
  ruleId: string,
  dashboardLeagueRankingRule: BodyType<DashboardLeagueRankingRule>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardLeagueRankingRuleItem>(
    {
      url: `/api/dashboard/v1/league-rankings/${leagueId}/rules/${ruleId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: dashboardLeagueRankingRule,
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerUpdateRuleMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerUpdateRule400
    | DashboardLeagueRankingsControllerUpdateRule401
    | DashboardLeagueRankingsControllerUpdateRule403
    | DashboardLeagueRankingsControllerUpdateRule404
    | DashboardLeagueRankingsControllerUpdateRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>,
    TError,
    { leagueId: string; ruleId: string; data: BodyType<DashboardLeagueRankingRule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>,
  TError,
  { leagueId: string; ruleId: string; data: BodyType<DashboardLeagueRankingRule> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>,
    { leagueId: string; ruleId: string; data: BodyType<DashboardLeagueRankingRule> }
  > = (props) => {
    const { leagueId, ruleId, data } = props ?? {};

    return dashboardLeagueRankingsControllerUpdateRule(leagueId, ruleId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerUpdateRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>
>;
export type DashboardLeagueRankingsControllerUpdateRuleMutationBody =
  BodyType<DashboardLeagueRankingRule>;
export type DashboardLeagueRankingsControllerUpdateRuleMutationError = ErrorType<
  | DashboardLeagueRankingsControllerUpdateRule400
  | DashboardLeagueRankingsControllerUpdateRule401
  | DashboardLeagueRankingsControllerUpdateRule403
  | DashboardLeagueRankingsControllerUpdateRule404
  | DashboardLeagueRankingsControllerUpdateRule429
>;

/**
 * @summary Update an automatic-update rule (dashboard)
 */
export const useDashboardLeagueRankingsControllerUpdateRule = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerUpdateRule400
    | DashboardLeagueRankingsControllerUpdateRule401
    | DashboardLeagueRankingsControllerUpdateRule403
    | DashboardLeagueRankingsControllerUpdateRule404
    | DashboardLeagueRankingsControllerUpdateRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>,
    TError,
    { leagueId: string; ruleId: string; data: BodyType<DashboardLeagueRankingRule> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerUpdateRule>>,
  TError,
  { leagueId: string; ruleId: string; data: BodyType<DashboardLeagueRankingRule> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerUpdateRuleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete an automatic-update rule, scoped to its league. Idempotent — deleting an unknown / cross-league rule returns 204 without error.
 * @summary Delete an automatic-update rule (dashboard)
 */
export const dashboardLeagueRankingsControllerDeleteRule = (
  leagueId: string,
  ruleId: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-rankings/${leagueId}/rules/${ruleId}`, method: "DELETE" },
    options
  );
};

export const getDashboardLeagueRankingsControllerDeleteRuleMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDeleteRule400
    | DashboardLeagueRankingsControllerDeleteRule401
    | DashboardLeagueRankingsControllerDeleteRule403
    | DashboardLeagueRankingsControllerDeleteRule404
    | DashboardLeagueRankingsControllerDeleteRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>,
    TError,
    { leagueId: string; ruleId: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>,
  TError,
  { leagueId: string; ruleId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>,
    { leagueId: string; ruleId: string }
  > = (props) => {
    const { leagueId, ruleId } = props ?? {};

    return dashboardLeagueRankingsControllerDeleteRule(leagueId, ruleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerDeleteRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>
>;

export type DashboardLeagueRankingsControllerDeleteRuleMutationError = ErrorType<
  | DashboardLeagueRankingsControllerDeleteRule400
  | DashboardLeagueRankingsControllerDeleteRule401
  | DashboardLeagueRankingsControllerDeleteRule403
  | DashboardLeagueRankingsControllerDeleteRule404
  | DashboardLeagueRankingsControllerDeleteRule429
>;

/**
 * @summary Delete an automatic-update rule (dashboard)
 */
export const useDashboardLeagueRankingsControllerDeleteRule = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDeleteRule400
    | DashboardLeagueRankingsControllerDeleteRule401
    | DashboardLeagueRankingsControllerDeleteRule403
    | DashboardLeagueRankingsControllerDeleteRule404
    | DashboardLeagueRankingsControllerDeleteRule429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>,
    TError,
    { leagueId: string; ruleId: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteRule>>,
  TError,
  { leagueId: string; ruleId: string },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerDeleteRuleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Enqueue a rankings recompute for one or more ranking categories for the given date. The work runs asynchronously as background jobs (the same `league-ranking-execute` SQS jobs the cron scheduler enqueues) — the endpoint returns `202 Accepted` with the number of jobs enqueued.
 * @summary Manually (re)generate rankings for a date (dashboard)
 */
export const dashboardLeagueRankingsControllerGenerate = (
  dashboardGenerateLeagueRanking: BodyType<DashboardGenerateLeagueRanking>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardGenerateLeagueRankingResult>(
    {
      url: `/api/dashboard/v1/league-rankings/generate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardGenerateLeagueRanking,
      signal,
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerGenerateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGenerate400
    | DashboardLeagueRankingsControllerGenerate401
    | DashboardLeagueRankingsControllerGenerate403
    | DashboardLeagueRankingsControllerGenerate404
    | DashboardLeagueRankingsControllerGenerate429
    | DashboardLeagueRankingsControllerGenerate503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>,
    TError,
    { data: BodyType<DashboardGenerateLeagueRanking> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>,
  TError,
  { data: BodyType<DashboardGenerateLeagueRanking> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>,
    { data: BodyType<DashboardGenerateLeagueRanking> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueRankingsControllerGenerate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>
>;
export type DashboardLeagueRankingsControllerGenerateMutationBody =
  BodyType<DashboardGenerateLeagueRanking>;
export type DashboardLeagueRankingsControllerGenerateMutationError = ErrorType<
  | DashboardLeagueRankingsControllerGenerate400
  | DashboardLeagueRankingsControllerGenerate401
  | DashboardLeagueRankingsControllerGenerate403
  | DashboardLeagueRankingsControllerGenerate404
  | DashboardLeagueRankingsControllerGenerate429
  | DashboardLeagueRankingsControllerGenerate503
>;

/**
 * @summary Manually (re)generate rankings for a date (dashboard)
 */
export const useDashboardLeagueRankingsControllerGenerate = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerGenerate400
    | DashboardLeagueRankingsControllerGenerate401
    | DashboardLeagueRankingsControllerGenerate403
    | DashboardLeagueRankingsControllerGenerate404
    | DashboardLeagueRankingsControllerGenerate429
    | DashboardLeagueRankingsControllerGenerate503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>,
    TError,
    { data: BodyType<DashboardGenerateLeagueRanking> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerGenerate>>,
  TError,
  { data: BodyType<DashboardGenerateLeagueRanking> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerGenerateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Flip the public-visibility flag of every row of one (league, ranking category, date) snapshot at once (the history "Public" toggle). 204 on success (including when the snapshot has no rows).
 * @summary Toggle a snapshot's public visibility (dashboard)
 */
export const dashboardLeagueRankingsControllerSetVisibility = (
  leagueId: string,
  rankingCategoryId: string,
  date: string,
  dashboardSetLeagueRankingVisibility: BodyType<DashboardSetLeagueRankingVisibility>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/league-rankings/${leagueId}/snapshots/${rankingCategoryId}/${date}/visibility`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardSetLeagueRankingVisibility,
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerSetVisibilityMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerSetVisibility400
    | DashboardLeagueRankingsControllerSetVisibility401
    | DashboardLeagueRankingsControllerSetVisibility403
    | DashboardLeagueRankingsControllerSetVisibility404
    | DashboardLeagueRankingsControllerSetVisibility429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>,
    TError,
    {
      leagueId: string;
      rankingCategoryId: string;
      date: string;
      data: BodyType<DashboardSetLeagueRankingVisibility>;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>,
  TError,
  {
    leagueId: string;
    rankingCategoryId: string;
    date: string;
    data: BodyType<DashboardSetLeagueRankingVisibility>;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>,
    {
      leagueId: string;
      rankingCategoryId: string;
      date: string;
      data: BodyType<DashboardSetLeagueRankingVisibility>;
    }
  > = (props) => {
    const { leagueId, rankingCategoryId, date, data } = props ?? {};

    return dashboardLeagueRankingsControllerSetVisibility(
      leagueId,
      rankingCategoryId,
      date,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerSetVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>
>;
export type DashboardLeagueRankingsControllerSetVisibilityMutationBody =
  BodyType<DashboardSetLeagueRankingVisibility>;
export type DashboardLeagueRankingsControllerSetVisibilityMutationError = ErrorType<
  | DashboardLeagueRankingsControllerSetVisibility400
  | DashboardLeagueRankingsControllerSetVisibility401
  | DashboardLeagueRankingsControllerSetVisibility403
  | DashboardLeagueRankingsControllerSetVisibility404
  | DashboardLeagueRankingsControllerSetVisibility429
>;

/**
 * @summary Toggle a snapshot's public visibility (dashboard)
 */
export const useDashboardLeagueRankingsControllerSetVisibility = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerSetVisibility400
    | DashboardLeagueRankingsControllerSetVisibility401
    | DashboardLeagueRankingsControllerSetVisibility403
    | DashboardLeagueRankingsControllerSetVisibility404
    | DashboardLeagueRankingsControllerSetVisibility429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>,
    TError,
    {
      leagueId: string;
      rankingCategoryId: string;
      date: string;
      data: BodyType<DashboardSetLeagueRankingVisibility>;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerSetVisibility>>,
  TError,
  {
    leagueId: string;
    rankingCategoryId: string;
    date: string;
    data: BodyType<DashboardSetLeagueRankingVisibility>;
  },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRankingsControllerSetVisibilityMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Permanently delete every row of one (league, ranking category, date) snapshot. Idempotent — deleting a non-existent snapshot returns 204.
 * @summary Delete a snapshot (dashboard)
 */
export const dashboardLeagueRankingsControllerDeleteSnapshot = (
  leagueId: string,
  rankingCategoryId: string,
  date: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/league-rankings/${leagueId}/snapshots/${rankingCategoryId}/${date}`,
      method: "DELETE",
    },
    options
  );
};

export const getDashboardLeagueRankingsControllerDeleteSnapshotMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDeleteSnapshot400
    | DashboardLeagueRankingsControllerDeleteSnapshot401
    | DashboardLeagueRankingsControllerDeleteSnapshot403
    | DashboardLeagueRankingsControllerDeleteSnapshot404
    | DashboardLeagueRankingsControllerDeleteSnapshot429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>,
    TError,
    { leagueId: string; rankingCategoryId: string; date: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>,
  TError,
  { leagueId: string; rankingCategoryId: string; date: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>,
    { leagueId: string; rankingCategoryId: string; date: string }
  > = (props) => {
    const { leagueId, rankingCategoryId, date } = props ?? {};

    return dashboardLeagueRankingsControllerDeleteSnapshot(
      leagueId,
      rankingCategoryId,
      date,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRankingsControllerDeleteSnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>
>;

export type DashboardLeagueRankingsControllerDeleteSnapshotMutationError = ErrorType<
  | DashboardLeagueRankingsControllerDeleteSnapshot400
  | DashboardLeagueRankingsControllerDeleteSnapshot401
  | DashboardLeagueRankingsControllerDeleteSnapshot403
  | DashboardLeagueRankingsControllerDeleteSnapshot404
  | DashboardLeagueRankingsControllerDeleteSnapshot429
>;

/**
 * @summary Delete a snapshot (dashboard)
 */
export const useDashboardLeagueRankingsControllerDeleteSnapshot = <
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDeleteSnapshot400
    | DashboardLeagueRankingsControllerDeleteSnapshot401
    | DashboardLeagueRankingsControllerDeleteSnapshot403
    | DashboardLeagueRankingsControllerDeleteSnapshot404
    | DashboardLeagueRankingsControllerDeleteSnapshot429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>,
    TError,
    { leagueId: string; rankingCategoryId: string; date: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDeleteSnapshot>>,
  TError,
  { leagueId: string; rankingCategoryId: string; date: string },
  TContext
> => {
  const mutationOptions =
    getDashboardLeagueRankingsControllerDeleteSnapshotMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * The distinct snapshot dates (`DD-MM-YYYY`) for a (league, ranking category), newest first — the data source for the rankings-page date picker.
 * @summary Snapshot dates for a (league, ranking category) (dashboard)
 */
export const dashboardLeagueRankingsControllerDates = (
  params: DashboardLeagueRankingsControllerDatesParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueRankingDates>(
    { url: `/api/dashboard/v1/league-rankings/dates`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueRankingsControllerDatesQueryKey = (
  params: DashboardLeagueRankingsControllerDatesParams
) => {
  return [`/api/dashboard/v1/league-rankings/dates`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueRankingsControllerDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDates400
    | DashboardLeagueRankingsControllerDates401
    | DashboardLeagueRankingsControllerDates403
    | DashboardLeagueRankingsControllerDates404
    | DashboardLeagueRankingsControllerDates429
  >,
>(
  params: DashboardLeagueRankingsControllerDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRankingsControllerDatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>
  > = ({ signal }) => dashboardLeagueRankingsControllerDates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRankingsControllerDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>
>;
export type DashboardLeagueRankingsControllerDatesQueryError = ErrorType<
  | DashboardLeagueRankingsControllerDates400
  | DashboardLeagueRankingsControllerDates401
  | DashboardLeagueRankingsControllerDates403
  | DashboardLeagueRankingsControllerDates404
  | DashboardLeagueRankingsControllerDates429
>;

export function useDashboardLeagueRankingsControllerDates<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDates400
    | DashboardLeagueRankingsControllerDates401
    | DashboardLeagueRankingsControllerDates403
    | DashboardLeagueRankingsControllerDates404
    | DashboardLeagueRankingsControllerDates429
  >,
>(
  params: DashboardLeagueRankingsControllerDatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerDates<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDates400
    | DashboardLeagueRankingsControllerDates401
    | DashboardLeagueRankingsControllerDates403
    | DashboardLeagueRankingsControllerDates404
    | DashboardLeagueRankingsControllerDates429
  >,
>(
  params: DashboardLeagueRankingsControllerDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRankingsControllerDates<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDates400
    | DashboardLeagueRankingsControllerDates401
    | DashboardLeagueRankingsControllerDates403
    | DashboardLeagueRankingsControllerDates404
    | DashboardLeagueRankingsControllerDates429
  >,
>(
  params: DashboardLeagueRankingsControllerDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Snapshot dates for a (league, ranking category) (dashboard)
 */

export function useDashboardLeagueRankingsControllerDates<
  TData = Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
  TError = ErrorType<
    | DashboardLeagueRankingsControllerDates400
    | DashboardLeagueRankingsControllerDates401
    | DashboardLeagueRankingsControllerDates403
    | DashboardLeagueRankingsControllerDates404
    | DashboardLeagueRankingsControllerDates429
  >,
>(
  params: DashboardLeagueRankingsControllerDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRankingsControllerDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRankingsControllerDatesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
